import * as S from './BetaBadge.styles'

export const BetaBadge = () => {
  return <S.BetaFlag>BETA</S.BetaFlag>
}
